/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

export const isConnected = (lastOn, lastOff) => {
  if (_.isNil(lastOn)) {
    return false;
  }
  if (_.isNil(lastOff)) {
    return true;
  }
  const onts = new Date(lastOn).valueOf();
  const offts = new Date(lastOff).valueOf();
  if (onts > offts) {
    return true;
  }
  return false;
};

export default {
  isConnected,
};




// WEBPACK FOOTER //
// ./src/utils/gateway.js